import {
  Component,
  Input,
  TemplateRef,
  OnInit,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CommunityService } from '../../../services/community.service';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { FormsModule } from '@angular/forms';
import { PostStoreService } from '../home/postService/post-store.service';
import { PostItemComponent } from '../post-item/post-item.component';
import { FreelancerDataService } from '../../../services/freelancer-data.service';
import { AuthService } from '../../guards/service/auth.service';

@Component({
  selector: 'app-feed',
  standalone: true,
  imports: [CommonModule, NgxDocViewerModule, FormsModule, PostItemComponent],
  templateUrl: './feed.component.html',
  styleUrls: ['./feed.component.css'],
})
export class FeedComponent implements OnInit {
  @Input() isLoading = false;
  @Input() communityID!: number;
  @Output() replyPosted = new EventEmitter<void>();
  availabiltyDurations: any;
  @Input() isRecruiter = false;
   @Input() isKARecruiter = false;

  communityPosts: any[] = [];
  selectedUser: any = null;
  isMobile = false;
  // replyPopupVisible = false;
  activeReplyPostId: number | null = null;
  parentReplyDepth = 0;
  parentPostId: number | null = null;
  isFadingOutReply = false;

  replyContent = '';
  replyImages: File[] = [];
  replyImagePreviews: string[] = [];
  replyImageError = '';
  expandedPosts: Set<number> = new Set();
  submittingReplyPostId: number | null = null;
  spaceID: number | undefined;
  profileDetails: any;
  userId: any;
  @Output() postCreated = new EventEmitter<void>();

  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    private communityService: CommunityService,
    private postStore: PostStoreService,
    private dataService: FreelancerDataService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.checkIsMobile();
    this.spaceID = parseInt(localStorage.getItem("spaceID") || "0", 10);
    this.getFreelancerPersonalInfo();
    this.getConsultantRegistrationDataList();
    this.postStore.posts$.subscribe(posts => {
      this.communityPosts = posts;
    });
  }
  getFreelancerPersonalInfo(): any {
    const headerValue = this.spaceID;

    this.dataService.getFreelancerProfile({}, headerValue).subscribe({
      next: (res) => {
        this.profileDetails = res.data;
        this.userId = this.profileDetails.user_id;
      },
      error: (err) => {
        console.error('Error fetching consultant registration:', err);
      }
    });

  }


  @HostListener('window:resize')
  onResize() {
    this.checkIsMobile();
  }

  checkIsMobile() {
    this.isMobile = window.innerWidth < 768;
  }
  toggleReply({
    replyId,
    replyDepth,
    parentPostId,
    onDone
  }: {
    replyId: number;
    replyDepth: number;
    parentPostId: number;
    onDone?: () => void;
  }): void {
    this.parentReplyDepth = replyDepth;
    this.parentPostId = parentPostId;

    if (this.isMobile) {
      this.activeReplyPostId = replyId;
    } else {
      this.activeReplyPostId = this.activeReplyPostId === replyId ? null : replyId;
    }

    this.communityService.getReplies(this.communityID, parentPostId).subscribe({
      next: (res) => {
        const replies = Array.isArray(res) ? res : res?.data.data || [];
        this.postStore.replaceRepliesToPost(parentPostId, replies);
      },
      error: () => {
        this.toastr.error('Failed to load replies.');
      },
      complete: () => {
        if (onDone) onDone();
      }
    });
  }







  // closeReplyPopup(): void {
  //   this.replyPopupVisible = false;
  //   this.clearReplyState();
  // }

  toggleExpanded(postId: number): void {
    this.expandedPosts.has(postId)
      ? this.expandedPosts.delete(postId)
      : this.expandedPosts.add(postId);
  }

  isExpanded(postId: number): boolean {
    return this.expandedPosts.has(postId);
  }

  onReplyFileChange(event: any) {
    const files = Array.from(event.target.files) as File[];
    const availableSlots = 5 - this.replyImages.length;

    if (files.length > availableSlots) {
      this.replyImageError = `You can only upload ${availableSlots} more image(s).`;
      files.splice(availableSlots);
    }

    for (const file of files) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const img = new Image();
        img.onload = () => {
          if (img.width > 4096 || img.height > 4096) {
            this.replyImageError = `${file.name} exceeds max resolution.`;
            return;
          }

          if (img.width > 1024) {
            const canvas = document.createElement('canvas');
            const ratio = img.height / img.width;
            canvas.width = 1024;
            canvas.height = 1024 * ratio;

            const ctx = canvas.getContext('2d');
            ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);

            canvas.toBlob(blob => {
              if (blob) {
                const resizedFile = new File([blob], file.name, { type: file.type });
                this.replyImages.push(resizedFile);
                this.createReplyPreview(resizedFile);
              }
            }, file.type);
          } else {
            this.replyImages.push(file);
            this.createReplyPreview(file);
          }
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }

    event.target.value = '';
  }

  createReplyPreview(file: File) {
    const reader = new FileReader();
    reader.onload = (e: any) => this.replyImagePreviews.push(e.target.result);
    reader.readAsDataURL(file);
  }

  removeReplyImage(index: number) {
    this.replyImages.splice(index, 1);
    this.replyImagePreviews.splice(index, 1);
  }

  submitReply({
    parentId,
    replyDepth,
    content,
    files
  }: {
    parentId: number;
    replyDepth: number;
    content: string;
    files: File[];
  }) {
    const hasContent = content.trim().length > 0;
    const hasImages = files.length > 0;

    if (!hasContent && !hasImages) {
      this.toastr.warning('Reply must contain text or an image');
      return;
    }

    this.submittingReplyPostId = parentId; 

    const fd = new FormData();
    fd.append('content', content);
    fd.append('parent_post_id', parentId.toString());
    fd.append('reply_depth', (replyDepth + 1).toString());
    files.forEach(file => fd.append('files', file));

    const queryParams = { bucket: 'Community/post-attachments' };

    this.communityService.createPost(this.communityID, fd, queryParams).subscribe({
      next: () => {
        this.toastr.success('Reply posted successfully');
        // Hide Local Replies 
        // this.toggleReply({
        //   replyId: parentId,
        //   replyDepth: replyDepth,
        //   parentPostId: parentId,
        //   onDone: () => (this.submittingReplyPostId = null)  
        // });

        this.submittingReplyPostId = null;
      },
      error: (err) => {
        const payload = err?.error?.error || err?.error || {};
        const msg = payload.description || 'Failed to create post.';

        this.toastr.error(msg);
        if (msg === 'Your account has been suspended.') {
          this.onLogout();
        }
      }
    });
  }

  clearReplyState() {
    this.replyContent = '';
    this.replyImages = [];
    this.replyImagePreviews = [];
    this.replyImageError = '';
    this.activeReplyPostId = null;
    // this.replyPopupVisible = false;
  }

  trackByPostId(index: number, post: any) {
    return post.id;
  }
  onDeletePost(postId: number): void {
    if (!postId) return;

    this.communityService.deletePost(this.communityID, postId).subscribe({
      next: () => {
        this.postCreated.emit();
        this.toastr.success('Post deleted successfully');
      },
      error: () => {
        this.toastr.error('Failed to delete post');
      }
    });
  }
  getConsultantRegistrationDataList(): void {
    this.dataService.getconsultantRegistration().subscribe({
      next: (res) => {
        const consultantRegistration = res?.data;
        this.availabiltyDurations = consultantRegistration?.durations || [];
        // console.log(this.availabiltyDurations);
      },
      error: (err) => {
        console.error('Error fetching consultant registration:', err);
      }
    });
  }

  onLogout(): void {
    this.authService.handleLogout();
  }

}
